import { defaultDiagramProperties } from '@/constants'
import { StructureStatus } from '@/endpoints/schemas/enums'

import { DiagramDataForm, DiagramFormUpdate, DiagramOverviewFormValues } from './types'

export const getInitialDiagramData = (name: string, code = '') => ({
	name,
	code,
	graph: {
		nodeDataArray: [],
		linkDataArray: [],
		modelData: {},
		skipsDiagramUpdate: false,
		properties: defaultDiagramProperties,
	},
})

export const DEFAULT_OVERVIEW_FORM_VALUES: DiagramOverviewFormValues = {
	name: '',
	comment: '',
	code: '',
	description: '',
	stereotype: undefined,
	status: StructureStatus.LOGICAL_IN_PROGRESS,
	responsiblePersonId: 0,
	responsibleAnalystId: 0,
}

export const pickOverviewFormValues = (
	form: DiagramDataForm,
): DiagramOverviewFormValues => ({
	name: form.name,
	comment: form.comment,
	code: form.code,
	description: form.description,
	stereotype: form.stereotype,
	status: form.status,
	responsiblePersonId: form.responsiblePersonId,
	responsibleAnalystId: form.responsibleAnalystId,
})

export const mergeDiagramForm = (
	form: DiagramDataForm,
	update: DiagramFormUpdate,
): DiagramDataForm => ({
	...form,
	...(update.code !== undefined ? { code: update.code } : {}),
	...(update.comment !== undefined ? { comment: update.comment } : {}),
	...(update.customAttributes !== undefined
		? { customAttributes: update.customAttributes }
		: {}),
	...(update.description !== undefined
		? { description: update.description }
		: {}),
	...(update.name !== undefined ? { name: update.name } : {}),
	...(update.objectSettings !== undefined
		? { objectSettings: update.objectSettings }
		: {}),
	...(update.ownerId !== undefined ? { ownerId: update.ownerId } : {}),
	...(update.ownerName !== undefined ? { ownerName: update.ownerName } : {}),
	...(update.responsibleAnalystId !== undefined
		? { responsibleAnalystId: update.responsibleAnalystId }
		: {}),
	...(update.responsibleAnalystName !== undefined
		? { responsibleAnalystName: update.responsibleAnalystName }
		: {}),
	...(update.responsiblePersonId !== undefined
		? { responsiblePersonId: update.responsiblePersonId }
		: {}),
	...(update.status !== undefined ? { status: update.status } : {}),
	...(update.stereotype !== undefined ? { stereotype: update.stereotype } : {}),
	...(update.graph !== undefined
		? { graph: { ...form.graph, ...update.graph } }
		: {}),
})
